"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/** formatting */
const H1_1 = __importDefault(require("../H1"));
const H2_1 = __importDefault(require("../H2"));
const H3_1 = __importDefault(require("../H3"));
const H4_1 = __importDefault(require("../H4"));
const H5_1 = __importDefault(require("../H5"));
const H6_1 = __importDefault(require("../H6"));
const Paragraph_1 = __importDefault(require("../Paragraph"));
const Blockquote_1 = __importDefault(require("../Blockquote"));
const Code_1 = __importDefault(require("../Code"));
const Pre_1 = __importDefault(require("../Pre"));
const Iframe_1 = __importDefault(require("../Iframe"));
/** elements */
const List_1 = __importDefault(require("../List"));
const Link_1 = __importDefault(require("../Link"));
const OL = (props) => react_1.default.createElement(List_1.default, Object.assign({ type: "ol" }, props));
const UL = (props) => react_1.default.createElement(List_1.default, Object.assign({}, props));
const Strong = (props) => react_1.default.createElement("strong", Object.assign({}, props));
const components = {
    h1: H1_1.default,
    h2: H2_1.default,
    h3: H3_1.default,
    h4: H4_1.default,
    h5: H5_1.default,
    h6: H6_1.default,
    p: Paragraph_1.default,
    blockquote: Blockquote_1.default,
    a: Link_1.default,
    ol: OL,
    ul: UL,
    strong: Strong,
    code: Code_1.default,
    pre: Pre_1.default,
    iframe: Iframe_1.default,
};
exports.default = components;
//# sourceMappingURL=markdownComponents.js.map